import { Badge, Button, IconButton } from "@mui/material";
import { formatDateBdata } from "components/utils";
import theme from "components/utils/theme";
import tables from '../../../../shared/Tables/table.module.scss'
import CopyIcon from "static/svgs/Copy";
import copy from "copy-to-clipboard";
import toast from "react-hot-toast";

export const getInvitesColumns = ({ handleResendInvite }) => [
    { field: "email", headerName: "Email", flex: 1.5 },
    { field: "adminName", headerName: "Invited By", flex: 1 },
    {
        field: "createdAt", headerName: "Invited on",
        renderCell: (params) => formatDateBdata(params?.row?.createdAt),
        flex: 1
    },
    {
        field: "status",
        headerName: "Status",
        renderCell: (params) => getInviteStatusBadge(params?.row?.status),
        flex: 1,
    },
    {
        field: "actions",
        headerName: "Actions",
        headerAlign: 'center',
        align: 'center',
        flex: 1,
        renderCell: (params) => {
            return (
                <>
                    {params.row.status === "pending" ?
                        <Button
                            variant="contained"
                            onClick={() => {
                                handleResendInvite(params?.row?._id)
                            }}
                            className={tables.actionBtn}
                            size="small"
                        >
                            Resend Invite
                        </Button> : "-"
                    }
                </>
            )
        },
    },
    {
        field: "inviteLink",
        headerName: "Invitation Link",
        headerAlign: 'center',
        align: 'center',
        flex: 1,
        renderCell: (params) => {
            return (
                <>
                    {params.row.status === "pending" ?
                        <IconButton
                            variant="contained"
                            onClick={() => {
                                handleCopy(params?.row?.inviteLink)
                            }}
                            className={tables.actionBtn}
                            size="small"
                        >
                            <CopyIcon fill={theme.palette.primary.main} />
                        </IconButton> : "-"
                    }
                </>
            )
        },
    },
];

const handleCopy = (link) => {
    copy(link);
    toast.success("Link Copied to Clipboard")
}

export const INVITE_DOWNLOAD_COLS = [
    { field: "email", headerName: "Email" },
    { field: "adminName", headerName: "Invited By" },
    { field: "createdAt", headerName: "Invited on", type: "date" },
    { field: "status", headerName: "Status" },
];


const getInviteStatusBadge = (status) => {
    switch (status) {
        case "pending":
            return <Badge badgeContent={status} sx={{
                "& .MuiBadge-badge": {
                    backgroundColor: theme.palette.warning.main,
                    color: theme.palette.white.main,
                },
            }} />
        case "accepted":
            return <Badge badgeContent={status}
                sx={{
                    "& .MuiBadge-badge": {
                        backgroundColor: theme.palette.success.main,
                        color: theme.palette.white.main,
                    },
                }}
            />
        default:

    }
}
export const userColumns = [
    { field: "username", headerName: "User Name", flex: 1 },
    { field: "email", headerName: "Email", flex: 1.5 },
    { field: "role", headerName: "Role", flex: 0.5 },
    { field: "gender", headerName: "Gender", flex: 0.5 },
    {
        field: "createdAt", headerName: "Joined on",
        renderCell: (params) => formatDateBdata(params?.row?.createdAt),
        flex: 1.5
    },
];

export const PORTAL_USER_DOWNLOAD_COLS = [
    { field: "username", headerName: "User Name" },
    { field: "email", headerName: "Email" },
    { field: "role", headerName: "Role" },
    { field: "gender", headerName: "Gender" },
    { field: "createdAt", headerName: "Joined on", type: "date" }
];
